var path = '/Users/saulsoto/Documents/workspace/spa/spa-frontend/src/components/breadcrumb/breadcrumb.html';
var html = "<ol class=breadcrumb> <li> <a href=#/ class=\"\">Inicio</a> </li> <li ng-repeat=\"step in steps\" ng-class=\"{active: $last}\" ng-switch=\"$last || !!step.abstract\"> <a ng-switch-when=false href={{step.ncyBreadcrumbLink}}>{{step.ncyBreadcrumbLabel | translate}}</a> <span ng-switch-when=true>{{step.ncyBreadcrumbLabel | translate}}</span> </li> </ol>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/components/breadcrumb/breadcrumb.html
// module id = 1928
// module chunks = 0